import { useContext, useMemo } from 'react'
import { EbolMatchingContext, useEbolMatchingContext } from '../EbolMatchingContext'
import { useOrderMovements } from '@api/useOrderMovements'

export const useSelectedBol = () => {
  const { selectedBolId, selectedOrderId } = useEbolMatchingContext()
  const { useOrderMovementDetailQuery } = useOrderMovements()
  const { data: orderDetail, status, fetchStatus } = useOrderMovementDetailQuery(selectedOrderId)
  const bol = useMemo(() => orderDetail?.bols?.find((x) => x.key === selectedBolId), [orderDetail?.bols, selectedBolId])
  return {
    data: bol,
    status,
    fetchStatus,
  }
}
